import type { ReactNode } from 'react'
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client'
import { NXDProvider } from '@n26/nxd'
import { LocalAuthProvider } from '@/features/auth/LocalAuthContext'
import { getOktaAuth } from '@/features/auth/okta'
import { OktaProvider } from '@/features/auth/OktaContext'
import { CONTRACT_VERSION } from '@/features/dashboard/api/schemas'
import { persistOptions, queryClient } from '@/shared/api/queryClient'
import { ThemeProvider } from '@/shared/theme/ThemeContext'

// Cached responses are only valid for the contract they were parsed with.
const persistWithContract = { ...persistOptions, buster: CONTRACT_VERSION }

export const AppProviders = ({ children }: { children: ReactNode }) => (
  <ThemeProvider>
    <NXDProvider locale='en'>
      <PersistQueryClientProvider
        client={queryClient}
        persistOptions={persistWithContract}
      >
        <OktaProvider oktaAuth={getOktaAuth()}>
          <LocalAuthProvider>{children}</LocalAuthProvider>
        </OktaProvider>
      </PersistQueryClientProvider>
    </NXDProvider>
  </ThemeProvider>
)
